import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { notification } from 'antd';
import {
  getStoredToken,
  handleUnauthorized,
  scheduleTokenRefresh,
} from './tokenManager';

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000
});

service.interceptors.request.use(config => {
  const jwtToken = getStoredToken();
  if (jwtToken) {
    config.headers['Authorization'] = `Bearer ${jwtToken}`;
  }
  return config;
}, error => {
  notification.error({
    message: 'Request Error',
    description: error.message
  });
  return Promise.reject(error);
});

service.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    if (!error.response) {
      notification.error({
        message: 'Network Error',
        description: 'Please check your internet connection'
      });
      return Promise.reject(error);
    }

    const { status, data } = error.response;

    if (status === 401 && !error.config._retry) {
      try {
        return await handleUnauthorized(error.config, service);
      } catch (refreshErr) {
        return Promise.reject(refreshErr);
      }
    }

    if (status === 403) {
      notification.error({
        message: 'Access Denied',
        description: data?.message || 'You do not have permission to access this resource'
      });
      return Promise.reject(error);
    }

    if (status === 404) {
      notification.error({
        message: 'Not Found',
        description: data?.message || 'The requested resource was not found'
      });
      return Promise.reject(error);
    }

    if (status === 500) {
      notification.error({
        message: 'Server Error',
        description: 'Something went wrong. Please try again later.'
      });
      return Promise.reject(error);
    }

    if (status >= 400) {
      console.error('API Error:', status, data);
    }

    return Promise.reject(error);
  }
);

export { scheduleTokenRefresh };
export default service;
